import { LoginResponseDto } from '../lib/api';

function checkPermissionCore(session: LoginResponseDto, feature: string) {
    return session.scope?.branches.some((branch) =>
        branch.access.some((permission) => permission.startsWith(`${feature}:`) || permission.startsWith('*:')),
    );
}

export function checkPermission(session: LoginResponseDto, feature?: string) {
    if (session.scope?.organization) {
        return true;
    }
    if (feature) {
        return checkPermissionCore(session, feature);
    }
    return false;
}

export function checkPermissionAny(session: LoginResponseDto, features?: string[]) {
    if (session.scope?.organization) {
        return true;
    }

    if (!features?.length) {
        return false;
    }

    return features.some((feature) => checkPermissionCore(session, feature));
}
